var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImgLoginGoogleMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "#F2F2F2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1303)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.8755 27.1028C36.8763 26.4167 36.8143 25.7319 36.69 25.0566H27.0769V28.9248H32.5689C32.4549 29.536 32.2157 30.1182 31.8657 30.6363C31.5158 31.1544 31.0624 31.5977 30.5328 31.9394V34.449H33.8301C35.7594 32.7081 36.8726 30.1438 36.8726 27.1009L36.8755 27.1028Z",
    fill: "#3E82F1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0789 36.8733C29.834 36.8733 32.1441 35.9783 33.8321 34.4512L30.5348 31.9416C29.6206 32.5417 28.4517 32.8968 27.0789 32.8968C24.4209 32.8968 22.1715 31.1371 21.3697 28.7734H17.96V31.3651C18.8094 33.0215 20.112 34.4138 21.7223 35.3865C23.3327 36.3592 25.1873 36.874 27.0789 36.8733Z",
    fill: "#32A753"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.3703 28.7738C20.9434 27.5419 20.9434 26.2063 21.3703 24.9744V22.3828H17.9605C17.2469 23.7767 16.8752 25.3146 16.8752 26.8741C16.8752 28.4336 17.2469 29.9715 17.9605 31.3654L21.3703 28.7738Z",
    fill: "#F9BB00"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0792 20.8514C28.5779 20.8514 29.9227 21.3564 30.9802 22.3474L33.9064 19.4789C32.1395 17.8651 29.8295 16.875 27.0811 16.875C25.1895 16.8743 23.3349 17.3891 21.7245 18.3618C20.1142 19.3345 18.8116 20.7268 17.9622 22.3832L21.3719 24.9749C22.1736 22.6112 24.4231 20.8514 27.0811 20.8514H27.0792Z",
    fill: "#E74133"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1303"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(16.875 16.875)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgLoginGoogleMedium);
export default __webpack_public_path__ + "static/media/img_login_google_medium.4ba211c43db668ad41b58b2d98bfda80.svg";
export { ForwardRef as ReactComponent };